import { css } from '@emotion/react';

const iconStyles = css`
  font-size: 16px;
  color: #000;
`;

export default iconStyles;
